module.exports = __webpack_public_path__ + "static/media/base-map-button-satellite-view.9beba2c0.png";